import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { CanvasProvider } from "client/contexts/ResizeEditor/Canvas";
import { Footer } from "components/modules/Layout/Footer/Footer";
import Head from "next/head";
import { RotateTutorial } from "components/modules/Tutorial/RotateTutorial/RotateTutorial";
import { RotateContent } from "components/modules/Content/RotateContent/RotateContent";
import { commonLanguageFiles } from "client/config";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { translateFunc } from "client/utils/translateFunc";
import dynamic from "next/dynamic";
import {TrustPilotSection} from "components/modules/TrustPilot/TrustPilotSection";
import React from "react";

const Rotate = dynamic<{}>(() => import("components/modules/Editors/Rotate/Rotate").then((mod) => mod.Rotate));

const Page = () => {
    const title = translateFunc("page-title");
    const description = translateFunc("meta-description");

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content="/social.png" />
                <meta property="twitter:card" content="summary" />
                <meta property="twitter:title" content={title} />
                <meta property="twitter:description" content={description} />
            </Head>
            <div className="max-w-1440 page-shadow">
                <CanvasProvider>
                    <Rotate />
                </CanvasProvider>

                <div className="max-w-1440 border-x">
                    <RotateContent />
                    <RotateTutorial />
                    <TrustPilotSection />
                    <Footer url="/rotate-image" />
                </div>
            </div>
        </>
    );
};

const files = ["rotate", "uploader", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <Page />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
